/**
 * Generated bundle index. Do not edit.
 */

export {HeaderModule} from './public_api';

export {HeaderComponent as ɵa} from './src/app/modules/header/header.component';